export default {"src":"/_next/static/media/instagram-icon.2c7985b7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};